// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';
import { PipeService } from '@client/app/filters/pipe-transformation.service';

@Pipe({
    name: 'isStatsSampleData',
    standalone: false,
})
export class IsStatsSampleDataPipe implements PipeTransform {

    constructor (private pipeService: PipeService) {}

    transform (domain: any): boolean {
        if (!domain) {
            return false;
        }
        const statistics = domain !== null && domain.features && domain.features.statistics;
        const monCustomerHasPlanPipeTransform = this.pipeService.get('monCustomerHasPlan');
        // eslint-disable-next-line
        // @ts-ignore
        return !statistics && monCustomerHasPlanPipeTransform('demo');
    }
}
